
import { Component, Vue } from "vue-property-decorator";

@Component
export default class WizardLogo extends Vue {
  async goHome() {
    if (this.$router.currentRoute.name != "home") {
      await this.$router.push({ name: "home" });
    }
  }
}
